/* eslint-disable react-hooks/exhaustive-deps */
import withValidarRecuperar from 'HOC/withValidarRecuperar';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import Breadcrumcomponent from 'components/BreadCrumbMex/BreadCrumb';
import BreadCurmbPasos from 'components/BreadCrumbMex/BreadCrumbTipo2';
import useIsCompraFinalizada from 'components/Crons/useIsCompraFinalizada';
import { SimpleCheckBox } from 'components/InputsMex/SimpleInputs';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { DropDownFilter } from 'components/InputsMex/inputs';
import MisDatosForm from 'components/MisDatosForm';
import Page from 'components/Page';
import { ambienteAplicacion } from 'constants/urls';
import { URLS_PHP_8 } from 'constants/urls_v2';
import { useNavbarContext } from 'contexts/NavbarContext';
import useAlbert from 'hooks/useAlbert';
import useUsuario from 'hooks/useUsuario';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { setBanderaPrimerPago, setParametrosPago } from 'redux/actions/cotizacion.actions';
import { PASOS_BREADCRUMBS, PRODUCTOS } from 'utils/constants';
import Loading from 'wrappers/Loading';
import './styles.scss';
import { urlAnios, urlGuardarDatosPaginaUno, urlMarcas, urlModelos, urlRecuperarCotizacionPaginaUno } from './urls';

const DatosAutoPantalla1 = ({ history, params: { idCotizacion }, addWarningToast }) => {
  useIsCompraFinalizada({ id: idCotizacion, ramo: PRODUCTOS.AUTO });
  useNavbarContext(PRODUCTOS.APINDIVIDUAL);
  const methods = useForm({
    mode: 'onChange',
  });
  const { handleSubmit, reset } = methods;
  const [loading, setLoading] = useState(true);
  const [catalogo, setCatalogo] = useState({});
  const [loadingModelos, setLoadingModelos] = useState(false);
  const [dataModelos, setDataModelos] = useState([]);
  const { isAgente, cliCodigoCore } = useUsuario();

  const [msgCheckBox, setMsgCheckBox] = useState([]);
  const [validacionEdad, setValidacionEdad] = useState([]);
  const [validarDatosModelos, setValidarDatosModelos] = useState(false);
  const codProducto = 'AUTO';
  const [dataAnio, setDataAnio] = useState([]);
  const [loadingAnios, setLoadingAnio] = useState(false);

  const checkRecuperado = 'Mi vehículo no ha sido recuperado por una aseguradora';
  const checkFronterizo = 'Mi vehículo no es fronterizo, legalizado o remarcado';
  const checkParticular = 'Mi vehículo es de uso particular sin fines de lucro';

  const { addAutoEvent, AUTO_EVENTS, AUTO_OPERATIONS } = useAlbert();
  const dispatch = useDispatch();

  const getData = async () => {
    setLoading(true);
    const body = {
      ambiente: ambienteAplicacion,
      datosCotizador: {
        prodCodigo: PRODUCTOS.AUTO,
        cotPasoCodigo: 'marcas',
        usuCotiza: {
          usuCodigo: cliCodigoCore || '',
        },
      },
    };

    const { transaccion, catalogo } = await ApiKeyFetch.instance().post(urlMarcas, body);
    console.log(JSON.stringify(catalogo));
    if (transaccion) {
      catalogo.marca = catalogo.marca?.map((item) => ({
        label: item.label,
        value: item,
      }));
      setCatalogo(catalogo);
      setMsgCheckBox(catalogo.mensajeCheckbox);
      // dispatch(setBanderaPrimerPago(catalogo?.banderaPrimerPago || false));
      if (catalogo.validacionEdad) {
        setValidacionEdad(catalogo.validacionEdad);
      } else {
        setValidacionEdad(validacionEdadDefault);
      }
    }

    if (idCotizacion) {
      const DataResumen = {
        cotDatos: {
          ambiente: ambienteAplicacion,
          cotCodigo: idCotizacion,
        },
      };
      const resResumen = await ApiKeyFetch.instance().post(urlRecuperarCotizacionPaginaUno, DataResumen);

      if (resResumen.transaccion && resResumen.cotConsulta) {
        if (resResumen?.cotConsulta?.polizaFinalizada) {
          addWarningToast(
            'No se puede modificar esta cotización puesto que ya se ha finalizado el proceso de emisión.'
          );
          history.push('/');
        }
        const { carContratante, carAsesor } = resResumen.cotConsulta;
        const { datosPlan } = carContratante;
        delete carContratante.datosPlan;

        if (resResumen?.cotConsulta?.catalogos?.modelos && resResumen?.cotConsulta?.catalogos?.anio) {
          setDataModelos(resResumen.cotConsulta.catalogos.modelos);
          setDataAnio(resResumen.cotConsulta.catalogos.anio);
        }

        const { codigoAgente } = carAsesor;
        const agente = catalogo?.permisos?.agentes?.find?.((agente) => agente.codigoAgente === codigoAgente);
        reset({
          datosAuto: {
            ...datosPlan,
          },
          datosCliente: {
            ...carContratante,
          },
          disclaimerAseguradora: true,
          disclaimerFronterizo: true,
          disclaimerUber: true,
          agente,
        });
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    obtenerParametros();
    getData();
  }, []);

  const obtenerParametros = () => {
    const DataParametros = {
      datosPago: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'obtenerParametros',
        prodCodigo: PRODUCTOS.AUTO,
        //polCodigo: idPoliza,
        numTarjeta: '4656565',
      },
    };

    ApiKeyFetch.instance()
      .post(URLS_PHP_8.emision.pago, DataParametros)
      .then((res) => {
        if (res.transaccion) {
          dispatch(setParametrosPago(res.pago));
        }
      });
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: 'AUTO',
      pasoCodigo: 'informacionCliente',
      items: {
        datosCliente: data.datosCliente,
        datosProducto: data.datosAuto,
        cotCodigo: idCotizacion || '',
        codigoUsuario: cliCodigoCore || '',
        usuCotiza: {
          usuCodigo: cliCodigoCore || '',
        },
        agente: data.agente,
      },
    };

    const res = await ApiKeyFetch.instance().post(urlGuardarDatosPaginaUno, Data);

    if (res.transaccion && res.id) {
      addAutoEvent(AUTO_OPERATIONS.albert_dtc_auto, AUTO_EVENTS.albert_get_quote);
      history.replace(`/auto/${res.id}`);
      history.push(`/auto-planes/${res.id}`);
    } else {
      methods.reset({ ...data });
      res.errorDescripcion.forEach((msg) => addWarningToast(msg, { autoDismiss: false }));
    }
    setLoading(false);
  };

  const onChangeModelos = async () => {
    const anio = methods.watch('datosAuto.anio');
    const marca = methods.watch('datosAuto.marca');

    if (!anio) {
      return methods.setError('datosAuto.anio', {
        type: 'custom',
        message: 'Seleccione un año',
      });
    }
    if (!marca) {
      return methods.setError('datosAuto.marca', {
        type: 'custom',
        message: 'Seleccione una marca',
      });
    }
    if (anio && marca) {
      setValidarDatosModelos(false);
      setDataModelos([]);
      setLoadingModelos(true);
      const body = {
        ambiente: ambienteAplicacion,
        datosCotizador: {
          prodCodigo: 'AUTO',
          cotPasoCodigo: 'modelo',
          marCodigoCore: marca.value,
          anioFabrica: anio.value,
        },
      };

      const { transaccion, catalogo: catModel } = await ApiKeyFetch.instance().post(urlModelos, body);

      if (transaccion && catModel.modelo) {
        setDataModelos(catModel.modelo);

        const testmodelo = catModel.modelo;
        if (testmodelo.length === 0) {
          setValidarDatosModelos(true);
        } else {
          setValidarDatosModelos(false);
        }
      }
      setLoadingModelos(false);
    }
  };

  const onSubmitError = (errors) => {
    let msg = 'Gracias por compartir los datos de tu auto,';
    let contador = 0;
    if (errors.disclaimerUber || errors.disclaimerFronterizo || errors.disclaimerAseguradora) {
      msg = msg + ' identificamos: ';
      if (errors.disclaimerAseguradora) {
        msg = msg + '"' + checkRecuperado + '", ';
        contador = contador + 1;
      }
      if (errors.disclaimerFronterizo) {
        msg = msg + '"' + checkFronterizo + '", ';
        contador = contador + 1;
      }
      if (errors.disclaimerUber) {
        msg = msg + '"' + checkParticular + '", ';
        contador = contador + 1;
      }
      if (contador > 1) {
        msg = msg + ' no están marcados';
      } else {
        msg = msg + ' no está marcado';
      }

      msg =
        msg +
        ', por el momento no podemos cotizar por las características del vehículo ¿Podemos ayudarte con otro modelo?';

      addWarningToast(msgCheckBox, { autoDismiss: false });
    }
  };

  const onChangeAnio = async () => {
    const marca = methods.watch('datosAuto.marca');

    if (!marca) {
      return methods.setError('datosAuto.marca', {
        type: 'custom',
        message: 'Seleccione un marca',
      });
    }
    if (marca) {
      setLoadingAnio(true);
      setDataAnio([]);
      setDataModelos([]);
      const body = {
        ambiente: ambienteAplicacion,
        datosCotizador: {
          prodCodigo: 'AUTO',
          cotPasoCodigo: 'anio',
          marCodigoCore: marca.value,
        },
      };

      const { transaccion, catalogo: catModel } = await ApiKeyFetch.instance().post(urlAnios, body);

      if (transaccion && catModel.anio) {
        setDataAnio(catModel.anio);
      }
      setLoadingAnio(false);
    }
  };

  return (
    <React.Fragment>
      <Loading loading={loading}>
        <div className="cr-content">
          <Page>
            <Breadcrumcomponent {...PASOS_BREADCRUMBS[codProducto].breadCrumb} />

            <BreadCurmbPasos {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[1]} />

            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmit, onSubmitError)}>
                <div className="row justify-content-center">
                  <div className="col-12 col-lg-5">
                    <div class="col-12 card-login-mex py-4">
                      <div className="container-accidentes">
                        <h3 className="font-mex" style={{ fontSize: '30px' }}>
                          {'Datos de mi auto'}
                        </h3>
                        <div className="form-group">
                          <SimpleContainer label={'Marca'} name="datosAuto.marca">
                            <DropDownFilter
                              name="datosAuto.marca"
                              optionLabel="label"
                              optionValue="value"
                              onChangeFn={async () => {
                                onChangeAnio();
                                methods.setValue('datosAuto.anio', null);
                                methods.setValue('datosAuto.modelo', null);
                                await methods.trigger(['datosAuto.modelo', 'datosAuto.anio']);
                              }}
                              rules={{
                                required: 'Este campo es obligatorio',
                              }}
                              options={catalogo.marca}
                              helpText={'Seleccione una marca'}
                            />
                          </SimpleContainer>
                        </div>
                        <div className="form-group">
                          <SimpleContainer label={'Año'} name="datosAuto.anio">
                            <DropDownFilter
                              name="datosAuto.anio"
                              optionLabel="label"
                              optionValue="value"
                              onChangeFn={() => {
                                onChangeModelos();
                                methods.setValue('datosAuto.modelo', null);
                              }}
                              rules={{
                                required: 'Este campo es obligatorio',
                              }}
                              //options={catalogo.anio}
                              options={dataAnio}
                              helpText={'Seleccione una año'}
                              loading={loadingAnios}
                            />
                          </SimpleContainer>
                        </div>
                        <div className="form-group">
                          <SimpleContainer
                            label={'Modelo'}
                            name="datosAuto.modelo"
                            helpText={
                              validarDatosModelos
                                ? 'Lo sentimos, por el momento no podemos cotizar con los parámetros de tu auto'
                                : ''
                            }
                          >
                            <DropDownFilter
                              name="datosAuto.modelo"
                              optionLabel="label"
                              optionValue="value"
                              options={dataModelos}
                              loading={loadingModelos}
                              rules={{
                                required: 'Este campo es obligatorio',
                              }}
                            />
                          </SimpleContainer>
                        </div>
                      </div>
                    </div>

                    <p></p>
                    <div className="disclaimers-auto">
                      <div className="col-12">
                        <SimpleCheckBox
                          name={'disclaimerAseguradora'}
                          id={'disclaimerAseguradora'}
                          label={checkRecuperado}
                          type={'slide'}
                          rules={{
                            validate: {
                              checked: (value) => {
                                if (value) {
                                  return true;
                                }
                                return 'Lo sentimos, sólo aseguramos autos que no provienen de salvamento';
                              },
                            },
                          }}
                        />

                        <SimpleCheckBox
                          name={'disclaimerFronterizo'}
                          id={'disclaimerFronterizo'}
                          label={checkFronterizo}
                          type={'slide'}
                          rules={{
                            validate: {
                              checked: (value) => {
                                if (value) {
                                  return true;
                                }
                                return 'Lo sentimos, por el momento no aseguramos vehículos que cuenten con las características señaladas';
                              },
                            },
                          }}
                        />

                        <SimpleCheckBox
                          name={'disclaimerUber'}
                          id={'disclaimerUber'}
                          label={checkParticular}
                          type={'slide'}
                          rules={{
                            validate: {
                              checked: (value) => {
                                if (value) {
                                  return true;
                                }
                                return 'Lo sentimos, por el momento sólo aseguramos automóviles de uso particular';
                              },
                            },
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-11 col-lg-5">
                    <MisDatosForm
                      methods={methods}
                      inputs={[
                        'usuGenero',
                        'usuFechaNacimiento',
                        'usuCorreo',
                        'usuNombre',
                        'usuTelefono2',
                        'usuCodigoPostal',
                        'disclaimerTerminos',
                      ]}
                      onSubmitError={onSubmitError}
                      overrideInputs={catalogo && catalogo.urlTerminosCondiciones}
                      dateProps={{
                        maxDate: moment()
                          .subtract(validacionEdad.edadMinima - 1, 'years')
                          .toDate(),
                        minDate: moment()
                          .subtract(validacionEdad.edadMaxima + 1, 'years')
                          .toDate(),
                      }}
                      dateRules={{
                        validate: (value) => {
                          const valueMoment = moment(value, 'yyy-MM-DD');
                          const fechaMinima = moment().subtract(validacionEdad.edadMinima, 'years');
                          const fechaMaxima = moment().subtract(validacionEdad.edadMaxima, 'years');
                          if (valueMoment.isBefore(fechaMaxima)) {
                            return 'La edad máxima es de ' + validacionEdad.edadMaxima + ' años cumplidos';
                          }
                          if (valueMoment.isAfter(fechaMinima)) {
                            return 'La edad mínima es de ' + validacionEdad.edadMinima + ' años cumplidos';
                          }
                          return true;
                        },
                      }}
                      dateHelpText={validacionEdad.msgEdad}
                      nombreRules={{
                        pattern: {
                          value: RegExp(/^[a-zA-ZáÁéÉíÍóÓúÚñÑüÜ.& ]+$/),
                          message: 'Solo se puede ingresar: mayúsculas y minúsculas.',
                        },
                      }}
                      clavesAgente={catalogo?.permisos?.agentes}
                      disclaimer={isAgente ? '' : undefined}
                    />
                  </div>
                </div>
              </form>
            </FormProvider>
          </Page>
        </div>
      </Loading>
    </React.Fragment>
  );
};

export default withValidarRecuperar(DatosAutoPantalla1);

const validacionEdadDefault = {
  edadMinima: 24,
  edadMaxima: 65,
  msgEdad: 'El rango de edad debe ser entre 24 y 65 años',
};
